<template>
  <div class="standard-page">
    <div class="detail-view-header">
      Message Template Detail
    </div>
    <div class="detail-view-deck">
      <b-card class="detail-view-info-card">
        <LabeledInfo label="Name" :value="messageTemplate.name" />
        <LabeledInfo label="Description" :value="messageTemplate.description" />
        <LabeledInfo label="SMS Body" :value="messageTemplate.sms_body" />
        <LabeledInfo label="Email Body" :value="messageTemplate.email_body" />
        <LabeledInfo label="Merchant" :value="messageTemplate.merchant" />
        <LabeledInfo label="Logo" :value="messageTemplate.logo" type="img" />
      </b-card>
      <b-card class="detail-view-info-card">
        <LabeledInfo label="ID" :value="messageTemplate.id" />
        <LabeledInfo label="PKID" :value="messageTemplate.pkid" />
        <LabeledInfo
          label="Deleted"
          :value="messageTemplate.deleted"
          type="boolean"
        />
        <LabeledInfo label="Created" :value="messageTemplate.created" />
        <LabeledInfo
          v-if="messageTemplate.created != messageTemplate.updated"
          label="Updated"
          :value="messageTemplate.updated"
        />
      </b-card>
    </div>
  </div>
</template>

<script>
import endpoints from '@/utils/endpoints.js'
/* TODO Message Template no IDs */

export default {
  data() {
    return {
      messageTemplate: {}
    }
  },
  mounted() {
    this.getMessageTemplate()
  },
  methods: {
    getMessageTemplate() {
      this.axios
        .get(
          endpoints.retrieveMessageTemplate(
            this.$route.params.merchantID,
            this.$route.params.messageTemplateID
          )
        )
        .then(res => {
          this.messageTemplate = res.data
        })
        .catch(err => {
          console.log('error', err)
        })
    }
  }
}
</script>
